fragment FindTrainingFragment on findTraining_Entry {
  typeHandle
}
